export { default as MpxAddressFormStandalone } from "./mpxAddressFormStandalone";
export { messages } from "./mpxAddressSuggestionForm";
